export { SEARCH_DEFAULT_PAGE_SIZE as DEFAULT_PAGE_SIZE } from '../../../constants/person-constants';

export const COLORS = {
  body: '#333',
  muted: '#777',
  border: '#e0e0e0',
  primary: '#0e7c86',
  primaryLight: '#e6f4f5',
  bgPage: '#f5f7fa',
  cardBg: '#fff',
};
